module.exports = __webpack_public_path__ + "static/N2N7s-a008a078ec6a7d01cdd8925d737c73a5.jpg";